var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/store-controls.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"removeProfileStoresConfirm") && (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "store")),"storeNumber") == (lineno = 3, colno = 81, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["editableStoreDelete"])))) {
output += "\n\n<div class=\"o-row c-store-controls c-store-result__wrapper--wrap\">\n\n    <div class=\"c-store-controls__remove-container\">\n\n        <p class=\"c-store-controls__title\" data-qa-remove-favorite-store-confirm-title>\n\n            ";
output += runtime.suppressValue((lineno = 11, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-removeStore",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n        </p>\n\n        <a href=\"\" class=\"c-store-controls__a js-account-remove-favorite-store\" data-store-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "store")),"storeNumber"), env.opts.autoescape);
output += "\" data-qa-remove-favorite-store-confirm>\n\n            ";
output += runtime.suppressValue((lineno = 17, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-yes",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n        </a>\n\n        <a href=\"\" class=\"c-store-controls__a js-account-remove-favorite-store-cancel\" data-qa-remove-favorite-store-cancel>\n\n            ";
output += runtime.suppressValue((lineno = 23, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-no",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n        </a>\n\n    </div>\n\n</div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/store-controls.j2"] , dependencies)